import axios from 'axios';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

// defaultni nastaveni axiosu
axios.defaults.baseURL = window.location.hostname.includes('localhost')
    ? process.env.REACT_APP_ISB_URL
    : `https://${window.location.hostname}/isbunfiled/api`;

ReactDOM.render(<App />, document.getElementById('root'));
